//checkbox, initial, signature, text, date
export default [
  {
    type: "checkbox",
    required: false,
    user_type: "all",
    x: 100,
    y: 100,
    w: 40,
    h: 40
  },
  {
    type: "initial",
    required: true,
    multiple_signees_enabled: true,
    user_type: "all",
    x: 100,
    y: 100,
    w: 100,
    h: 50
  },
  {
    type: "signature",
    required: true,
    multiple_signees_enabled: true,
    user_type: "all",
    x: 100,
    y: 100,
    w: 200,
    h: 50
  },
  {
    type: "text",
    required: false,
    user_type: "all",
    x: 100,
    y: 100,
    w: 200,
    h: 50
  },
  {
    type: "text_display",
    label: "",
    required: false,
    user_type: "all",
    x: 100,
    y: 100,
    w: 200,
    h: 50
  },
  {
    type: "date",
    required: false,
    user_type: "all",
    x: 100,
    y: 100,
    w: 200,
    h: 50
  },
  {
    type: "mappable",
    required: false,
    user_type: "all",
    x: 100,
    y: 100,
    w: 200,
    h: 50
  }
]
